import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ApplicationUtilsService } from "../../../global_services/application_utils/application_utils.service";

export const AppRoutes = [];

@Component({
  selector: "app-cov-header",
  templateUrl: "./cov-header.component.html",
  styleUrls: ["./cov-header.component.css", "../../../app.component.css"],
  standalone: false,
})
export class CovHeaderComponent implements OnInit {
  @Input() certificateNumber: string;
  @Input() verificationNumber: string;
  @Input() captchaInput: string;

  hover: boolean[];
  prompts: any[];

  constructor(public appUtils: ApplicationUtilsService) {
    this.hover = [false, false];
  }

  ngOnInit() {}

  get language() {
    return this.appUtils.getLanguage();
  }

  set language(language) {
    this.appUtils.setLanguage(language);
  }

  changeLanguage(language) {
    this.language = language;
    this.appUtils.setCertificateNumber(this.certificateNumber);
    this.appUtils.setVerificationNumber(this.verificationNumber);
    this.appUtils.setCaptchaInput(this.captchaInput);
    this.appUtils.setResultaatError(null);
  }
}
